class Workshop3Activite5CsvGenerator {
  constructor(progressionData, lang = "fr") {
    this.progressionData = progressionData || {};
    this.eventProgression = this.progressionData.eventProgression || [];
    this.globalStats = this.progressionData.globalStats || {};
    this.lang = lang;
    this.labels = lang === "en" ? this.getEnLabels() : this.getFrLabels();
  }

  getFrLabels() {
    return {
      title:
        "ATELIER 3 - ACTIVITÉ 5 : PROGRESSION DES PLANS DE TRAITEMENT DU RISQUE",
      eventProgression: "PROGRESSION DES ÉVÉNEMENTS REDOUTÉS",
      eventName: "Nom de l'événement",
      securityPillar: "Pilier de sécurité",
      gravity: "Gravité",
      businessValue: "Valeur métier",
      supportAssets: "Actifs supports",
      a1MeasuresCount: "Nombre de mesures A1",
      a3MeasuresCount: "Nombre de mesures A3",
      status: "Statut",
      treatmentRate: "Taux de traitement (%)",
      enriched: "Enrichi (A1 + A3)",
      partiallyTreated: "Partiellement traité",
      notTreated: "Non traité",
      globalStats: "STATISTIQUES GLOBALES",
      totalEvents: "Total des événements redoutés",
      enrichedEvents: "Événements enrichis (A1 + A3)",
      partiallyTreatedEvents: "Événements partiellement traités",
      notTreatedEvents: "Événements non traités",
      enrichmentRate: "Taux d'enrichissement (%)",
      treatmentRate: "Taux de traitement global (%)",
      yes: "Oui",
      no: "Non",
    };
  }

  getEnLabels() {
    return {
      title: "WORKSHOP 3 - ACTIVITY 5: RISK TREATMENT PLAN PROGRESSION",
      eventProgression: "PROGRESSION OF FEARED EVENTS",
      eventName: "Event Name",
      securityPillar: "Security Pillar",
      gravity: "Gravity",
      businessValue: "Business Value",
      supportAssets: "Support Assets",
      a1MeasuresCount: "A1 Measures Count",
      a3MeasuresCount: "A3 Measures Count",
      status: "Status",
      treatmentRate: "Treatment Rate (%)",
      enriched: "Enriched (A1 + A3)",
      partiallyTreated: "Partially Treated",
      notTreated: "Not Treated",
      globalStats: "GLOBAL STATISTICS",
      totalEvents: "Total Feared Events",
      enrichedEvents: "Enriched Events (A1 + A3)",
      partiallyTreatedEvents: "Partially Treated Events",
      notTreatedEvents: "Not Treated Events",
      enrichmentRate: "Enrichment Rate (%)",
      treatmentRate: "Global Treatment Rate (%)",
      yes: "Yes",
      no: "No",
    };
  }

  createSectionHeader(title, colSpan = 9) {
    return `<tr><td colspan="${colSpan}" style="background-color: #1E40AF; color: white; font-weight: bold; font-size: 14px; padding: 10px 8px;">${title}</td></tr>`;
  }

  createTableHeader(headers) {
    return `<tr>
              ${headers.map((h) => `<td style="background-color: #3B82F6; color: white; font-weight: bold; padding: 8px; border: 1px solid #93C5FD;">${h}</td>`).join("")}
            </tr>`;
  }

  createDataRow(cells) {
    return `<tr>
              ${cells.map((c) => `<td style="padding: 6px 8px; border: 1px solid #E2E8F0; vertical-align: top;">${c || ""}</td>`).join("")}
            </tr>`;
  }

  generateEventProgressionSection() {
    if (!this.eventProgression || this.eventProgression.length === 0) {
      return (
        this.createSectionHeader(this.labels.eventProgression) +
        `<tr><td colspan="9" style="padding: 8px; color: #6B7280; font-style: italic;">${this.lang === "en" ? "No feared events defined" : "Aucun événement redouté défini"}</td></tr>`
      );
    }

    const headers = [
      this.labels.eventName,
      this.labels.securityPillar,
      this.labels.gravity,
      this.labels.businessValue,
      this.labels.supportAssets,
      this.labels.a1MeasuresCount,
      this.labels.a3MeasuresCount,
      this.labels.status,
      this.labels.treatmentRate,
    ];

    const rows = this.eventProgression
      .map((event) => {
        return this.createDataRow([
          event.name || "",
          event.securityPillar || "",
          event.gravity || "",
          event.businessValueDetails?.name || "",
          event.supportAssetsFormatted || "",
          event.treatmentDetails?.a1Count || 0,
          event.treatmentDetails?.a3Count || 0,
          event.statusLabel || "",
          event.progressionRate || 0,
        ]);
      })
      .join("");

    return (
      this.createSectionHeader(this.labels.eventProgression) +
      this.createTableHeader(headers) +
      rows
    );
  }

  generateGlobalStatsSection() {
    if (!this.globalStats || Object.keys(this.globalStats).length === 0) {
      return "";
    }

    const headers = [this.labels.globalStats, "", "", "", "", "", "", "", ""];

    const statRows = [
      this.createDataRow([
        `${this.labels.totalEvents}:`,
        this.globalStats.totalEvents || 0,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]),
      this.createDataRow([
        `${this.labels.enrichedEvents}:`,
        this.globalStats.enrichedEvents || 0,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]),
      this.createDataRow([
        `${this.labels.partiallyTreatedEvents}:`,
        this.globalStats.partiallyTreatedEvents || 0,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]),
      this.createDataRow([
        `${this.labels.notTreatedEvents}:`,
        this.globalStats.notTreatedEvents || 0,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]),
      this.createDataRow([
        `${this.labels.enrichmentRate}:`,
        this.globalStats.enrichmentRate || 0,
        "%",
        "",
        "",
        "",
        "",
        "",
        "",
      ]),
      this.createDataRow([
        `${this.labels.treatmentRate}:`,
        this.globalStats.treatmentRate || 0,
        "%",
        "",
        "",
        "",
        "",
        "",
        "",
      ]),
    ].join("");

    return (
      this.createSectionHeader(this.labels.globalStats) +
      this.createTableHeader(headers) +
      statRows
    );
  }

  generateHtml() {
    const sections = [
      this.generateEventProgressionSection(),
      this.generateGlobalStatsSection(),
    ].filter(Boolean); // Remove empty sections

    return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
    table { border-collapse: collapse; width: 100%; font-family: Calibri, Arial, sans-serif; }
    tr:nth-child(even) td { background-color: #F8FAFC; }
    tr:hover td { background-color: #EFF6FF; }
    tr { page-break-inside: avoid; }
</style>
</head>
<body>
<table>
${sections.join("\n\n")}
</table>
</body>
</html>`;
  }

  download(filename) {
    const htmlContent = this.generateHtml();
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + htmlContent], {
      type: "application/vnd.ms-excel;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  }
}

export default Workshop3Activite5CsvGenerator;
